import React from 'react';
import { Button, Menu, ScrollArea } from '@mantine/core';
import { TbChevronDown } from 'react-icons/tb';

interface OptionType {
  id: string | number;
  name: string;
  [key: string]: any;
}

interface FilterDropdownProps {
  label: string;
  options: OptionType[];
  value: OptionType | null;
  onChange: (option: OptionType | null) => void;
  leftSection?: React.ReactNode;
  placeholder?: string;
}
export function FilterDropdown({
  label,
  options,
  value,
  onChange,
  leftSection,
  placeholder = 'All'
}: FilterDropdownProps) {
  return (
    <Menu shadow="md" width={200} zIndex={1100}>
      <Menu.Target>
        <Button
          size="sm"
          variant="default"
          leftSection={leftSection}
          rightSection={<TbChevronDown size={16} />}
          styles={{
            root: {
              color: value ? '#000' : '#868E96',
              borderColor: value ? '#228BE6' : '#DEE2E6'
            }
          }}
        >
          {value ? value.name : label}
        </Button>
      </Menu.Target>
      <Menu.Dropdown p="8px">
        <ScrollArea.Autosize scrollbarSize={14} scrollHideDelay={500} mah="300px">
          <Menu.Item
            onClick={() => onChange(null)}
            fz="14px"
            bg={!value ? 'gray.1' : 'transparent'}
          >
            {placeholder}
          </Menu.Item>
          {options.map(option => (
            <Menu.Item
              key={option.id}
              onClick={() => onChange(option)}
              fz="14px"
              bg={value?.id === option.id ? 'gray.1' : 'transparent'}
            >
              {option.name}
            </Menu.Item>
          ))}
        </ScrollArea.Autosize>
      </Menu.Dropdown>
    </Menu>
  );
}
